import GameStreak from "../components/GameStreak";

const BottomLeft = ({ gameData }) => {
  if (!gameData) return null;

  return (
    <div className="text-white">
      <GameStreak gameStatistics={gameData.GameStreakHomeTeam} team={gameData.HomeTeam} />
    </div>
  );
};

export default BottomLeft;
